import { Injectable } from '@angular/core';
import { WorkScheduleFindInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkScheduleService extends BaseService {
  protected baseUrl = '/basis/security/work-schedule';

  public restoreOne(id: number): Observable<WorkScheduleFindInterface> {
    return this.http.patch<WorkScheduleFindInterface>(`${this.baseUrl}/${id}`, {});
  }
}
